import styled from "styled-components";

export const ZelleContainer = styled.div`
  background: #010606;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const ZelleImg = styled.img`
  width: 80px;
  height: 80px;
`;
